module.exports = __webpack_public_path__ + "media/images/icons/close-0d260741cc0d78828b7b428e5b63f044.svg";